




















import { defineComponent } from "@vue/composition-api";
import BaseButton from "@/components/BaseButton";
import BaseConfirm from "@/components/BaseConfirm";

export default defineComponent({
  name: "VaultDeleteFilesConfirm",
  components: { BaseConfirm, BaseButton },
  props: {
    filesCount: { type: Number, required: true },
    show: { type: Boolean, required: true },
    loading: { type: Boolean, default: false },
  },
});
